import type { FormEvent } from 'react';
import type { TableCheckboxData } from '@/ui/Table';

export type GroupEditorAdapterBindings<TTarget, TData, TItem> = {
    openedGroupEditor: TTarget | null;
    groupEditorData: TData | null;
    groupEditorNameDraft: string;
    setGroupEditorNameDraft: (value: string) => void;
    isGroupEditorLoading: boolean;
    groupEditorError: string | null;
    isGroupEditorNameSaving: boolean;
    isGroupEditorUngrouping: boolean;
    normalizedGroupEditorNameDraft: string;
    hasGroupEditorNameChanged: boolean;
    isHeaderChecked: boolean;
    checkboxData: TableCheckboxData[];
    onGroupEditorOpen: (group: TTarget) => void;
    onGroupEditorClose: () => void;
    onGroupEditorModalVisibilityChange: (isShown: boolean) => void;
    renameGroupEditor: () => Promise<void>;
    onGroupEditorRenameSubmit: (event: FormEvent<HTMLFormElement>) => void;
    onHeaderCheckboxChange: (checked: boolean) => void;
    onCheckboxChange: (checked: boolean, item: TItem) => void;
};

export type GroupEditorCommonBindings<TTarget, TData, TItem> = {
    openedGroupEditor: TTarget | null;
    groupEditorData: TData | null;
    groupEditorNameDraft: string;
    setGroupEditorNameDraft: (value: string) => void;
    isGroupEditorLoading: boolean;
    groupEditorError: string | null;
    isGroupEditorNameSaving: boolean;
    isGroupEditorUngrouping: boolean;
    normalizedGroupEditorNameDraft: string;
    hasGroupEditorNameChanged: boolean;
    isGroupEditorHeaderChecked: boolean;
    groupEditorCheckboxData: TableCheckboxData[];
    onGroupEditorOpen: (group: TTarget) => void;
    onGroupEditorClose: () => void;
    onGroupEditorModalVisibilityChange: (isShown: boolean) => void;
    renameGroupEditor: () => Promise<void>;
    onGroupEditorRenameSubmit: (event: FormEvent<HTMLFormElement>) => void;
    onGroupEditorHeaderCheckboxChange: (checked: boolean) => void;
    onGroupEditorCheckboxChange: (checked: boolean, item: TItem) => void;
};

export const buildGroupEditorCommonBindings = <TTarget, TData, TItem>(
    groupEditor: GroupEditorAdapterBindings<TTarget, TData, TItem>,
): GroupEditorCommonBindings<TTarget, TData, TItem> => ({
    openedGroupEditor: groupEditor.openedGroupEditor,
    groupEditorData: groupEditor.groupEditorData,
    groupEditorNameDraft: groupEditor.groupEditorNameDraft,
    setGroupEditorNameDraft: groupEditor.setGroupEditorNameDraft,
    isGroupEditorLoading: groupEditor.isGroupEditorLoading,
    groupEditorError: groupEditor.groupEditorError,
    isGroupEditorNameSaving: groupEditor.isGroupEditorNameSaving,
    isGroupEditorUngrouping: groupEditor.isGroupEditorUngrouping,
    normalizedGroupEditorNameDraft: groupEditor.normalizedGroupEditorNameDraft,
    hasGroupEditorNameChanged: groupEditor.hasGroupEditorNameChanged,
    isGroupEditorHeaderChecked: groupEditor.isHeaderChecked,
    groupEditorCheckboxData: groupEditor.checkboxData,
    onGroupEditorOpen: groupEditor.onGroupEditorOpen,
    onGroupEditorClose: groupEditor.onGroupEditorClose,
    onGroupEditorModalVisibilityChange: groupEditor.onGroupEditorModalVisibilityChange,
    renameGroupEditor: groupEditor.renameGroupEditor,
    onGroupEditorRenameSubmit: groupEditor.onGroupEditorRenameSubmit,
    onGroupEditorHeaderCheckboxChange: groupEditor.onHeaderCheckboxChange,
    onGroupEditorCheckboxChange: groupEditor.onCheckboxChange,
});
